import { sentenceCase } from 'change-case';
import { formatISO } from 'date-fns';
import React from 'react';
import styled from 'styled-components';
import { ApiClient } from '../../../../api/ApiClient';
import { v2 } from '../../../../api/ApiInterfaceV2';
import { useLoader } from '../../../../platform/Hook';
import { Colors } from '../../../../ui';
import { InfoView } from '../../../../ui/InfoView';
import { LoadingGuard } from '../../../../ui/LoadingGuard';
import { Table } from '../../../../ui/Table';
import { AppNavigator } from '../../../AppNavigator';
import { useResolve } from '../../../Container';
import { Copy } from '../../../dashboard/elements/LayoutElements';
import { TableFrame } from '../../ManageElements';

const { Section, LargeHeading } = InfoView;

const colorSelector = (type: string) => {
    switch (type.toLowerCase()) {
        case 'subscription_created': return Colors.positive;
        case 'subscription_updated': return Colors.positive;
        case 'subscription_cancelled': return Colors.mystery;
        case 'subscription_payment_success': return Colors.primary;
        case 'subscription_payment_failed': return Colors.negative;
        case 'subscription_payment_refunded': return Colors.primary;
        default: return Colors.gray400;
    }
};

const ActionBadge = styled.div<{ color }>`
    display: inline-block;
    position: relative;
    padding: .2rem .4rem;
    border-radius: .3rem;
    color: white;
    font-weight: 450;
    text-transform: uppercase;
    font-size: .875rem;
    background: ${p => p.color};
`;

export const ManageLegacyBillingHistoryView = React.memo(() => {

    const api = useResolve(ApiClient);
    const nav = useResolve(AppNavigator);

    const [loading, items] = useLoader(async () => await api.exec(v2.admin.billing.history()), []);

    return <LoadingGuard loading={false}>
        <Section flush>
            <LargeHeading>
                Legacy Change History
            </LargeHeading>
            <Copy>All changes to your organizations billing are logged here.</Copy>
        </Section>
        <TableFrame>
            <Table>
                <Table.Head>
                    <Table.Row>
                        <Table.Cell>Type</Table.Cell>
                        <Table.Cell>Message</Table.Cell>
                        <Table.Cell>When</Table.Cell>
                        <Table.Cell></Table.Cell>
                    </Table.Row>
                </Table.Head>
                <Table.Body>
                    {items && items.map(x =>
                        <Table.Row key={x.id}>
                            <Table.Cell>
                                <ActionBadge color={colorSelector(x.type)}>
                                    {sentenceCase(x.type)}
                                </ActionBadge>
                            </Table.Cell>
                            <Table.Cell>{x.message}</Table.Cell>
                            <Table.Cell>{formatISO(x.createdAt).replace(/[TZ]/g, ' ')}</Table.Cell>
                        </Table.Row>
                    )}
                </Table.Body>
            </Table>
        </TableFrame>
    </LoadingGuard>;
});
